const getRevisionSubTaskStateSeverity = (subTask) => {
  if (subTask.state === "FINISHED") {
    if (subTask.cause_of_unfinished === "FAULT") {
      return "warning"
    }

    return "success"
  }

  if (subTask.state === "NOT_FINISHED") {
    return "danger"
  }

  if(subTask.state === "PARTIALY_FINISHED") {
    return "warning"
  }

  return "info"
}

export default getRevisionSubTaskStateSeverity
